<!--
  name : 김혜진
  desc : 사내 계약서 업로드
  date : 2021-08-04
-->
<template>
  <v-row no-gutters>

    <!--내용-->
    <v-col cols="12" class="write_conYscroll">
      <v-row no-gutters>
        <v-col cols="12" class="row_mb-20">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="8">
              <div class="dot_tt">사내 계약서 업로드</div>
              <div class="txtst_info_gray">계약서 파일을 업로드해 주세요. 파일명은 <strong style="color:#CC0303"> [{{ruleForm.fileName === ''?'계약명':ruleForm.fileName}}_아이디_이름]</strong>  형식을 지켜 주세요.
                <p>예) 임시계약_hong_홍길동</p>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="4" class="mdTa-r_sdTa-l">
              <v-btn class="btn18_00" outlined @click="fnPdfDown()"><span class="btn-icon_download"></span>사내 계약 가이드</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="row_mb-20">
          <v-text-field class="inputH48_01 W100"
            label="계약명"
            placeholder="계약명을 입력해주세요"
            ref="fileNameForm"
            v-model="ruleForm.fileName"
            :rules="rules.subjectRules"
            maxlength="200"
            outlined
            dense
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" class="row_mb-20">
          <v-row no-gutters class="WCpnstep1_file_inP_box justify-center">
            <v-col cols="12" sm="12" md="6" lg="6">
              <div class="WCpnstep1_file_inPCol_box">
                <v-file-input
                  class="inputH48_01 WaddWCpn Hauto"
                  ref="contractUpload"
                  label="계약서 파일"
                  placeholder="여기를 눌러 계약서를 선택해주세요"
                  v-model="uploadFile"
                  @change="pushFile"
                  :accept="upload.uploadCtrPaperAccept"
                  outlined
                  chips
                  dense
                  multiple
                  >
                </v-file-input>

                <div class="addWCpn_ul_box" align="left">
                  <ul>
                    <li>- <font class="fc_C03">등록된 사원만</font> 사내 계약이 가능합니다.</li>
                    <li>- <font class="fc_C03">10MB 이하</font>의 파일만 선택 가능합니다.</li>
                    <li>- 업로드한 계약서 파일은 50건까지 업로드 할 수 있습니다.</li>
                    <li>- 업로드한 계약서 파일은 PDF 파일로 변환됩니다.</li>
                    <li>- 계약서 파일을 선택한 후 <font class="fc_C03">[업로드] 버튼</font>을 클릭해야 계약서 업로드가 완료됩니다.</li>
                  </ul>
                </div>
              </div>
            </v-col>

            <!--*테이블-->
            <v-col class="WCpn_cerList-col" cols="12" sm="12" md="6" lg="6">
              <v-row no-gutters class="WCpn_cerListY-scroll">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                <!--List-->
                <v-card v-for="(fileList, index) of fileList" :key="index" class="WCpn_cerListCon">
                  <v-list-item class="carD_box">
                    <div class="listNum mr-1">{{index + 1}}</div>
                    <ul class="list_carD02_ulTxtBox">
                      <li class="li_mg02">
                        <span class="txt_txt01">{{fileList.name}}</span>
                      </li>
                    </ul>
                  </v-list-item>
                  <v-btn class="btnO_C04 del_list" @click="RemovefileList(fileList.name, index)"><span class="icon"></span></v-btn>
                </v-card>

                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-col>
    <!--/내용-->

  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
  </v-row>
</template>
<script>
import { uploadOfficeContract, inspectContactInfo } from '@/api/setting/officeContract'

export default {
  name: 'step01',
  components: {
  },
  filters: {
  },
  props:{
  },
  data () {
    return {
      // 업로드된 파일 리스트 (업로드 된 이후에 사용되는듯..)
      fileList: [],
      // 업로드 할 파일 리스트
      uploadFile: [],
      // 업로드 파일 사이즈 제한 (MB)
      limitFileSize: 10,
      // 최대 계약서 업로드 갯수
      limitFileNum: 50,
      // 업로드하는 파일들 이름(종류)
      ruleForm: {
        fileName: ''
      },
      // 사내계약이 가능한 사원 수
      posibleMemberNum: 0,
			upload: {
        uploadCtrPaperAccept: '.jpg, .jpeg, .gif, .bmp, .png, .doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx',
			},
			rules: {
				subjectRules: [
					v => !!v || '계약명을 입력해주세요.',
					v => v.match(this.pattern) || '특정 특수 문자(\\ / * : ? " < > | _) 사용 불가'
				],
			},
      pattern: '^[ㄱ-ㅎ|가-힣|ㅏ-ㅣ|a-z|A-Z|0-9]*[^\\\\|/?*<>_]*$',
      // 허용 안되는 특수문자
      illegalText: '\\ / * : ? " < > | _',
      fileIndex: 0,
      fileData: new FormData(),
      fileValidation: false,
      // 기업 관리자이거나 계약 관리자 여부 확인
      isAdmin: false
    }
  },
  created () {
  },
  mounted () {
    this.inspectContactInfo()
  },
  methods: {
    inspectContactInfo () {
      inspectContactInfo().then(response => {
        if (response.rdata.rcode === 20000) {
          this.posibleMemberNum = response.rdata.membersNum
          if (this.posibleMemberNum <= 0) {
            this.$refs.confirm.open('alert','사내계약', '계약을 할 수 있는 사원이 없습니다.<br>설정>사원 관리 탭 으로 이동해서 사원을 등록해주세요.').then(() => {
              this.$router.push('crew')
            })
          }
        } else {
          this.$refs.confirm.open('alert','사내계약', '사내계약이 가능한 사용자 조회를 실패했습니다. ( error : ' + response.rdata.rmessage + ' )<br>사원 관리 탭 으로 이동합니다.').then(() => {
            this.$router.push('crew')
          })
        }
      }).catch(e => {
        console.error(e)
        this.$refs.confirm.open('alert','사내계약', '기업회원만 이용 가능합니다.').then(() => {
          this.$router.push('main')
        })
      })
    },

    pushFile (file) {
      for (var i in file) {
        if (file[i].size < 10000000) {
          if (this.fileList.length < this.limitFileNum) {
            this.fileList.push(file[i])
          } else {
            this.$refs.confirm.open('alert','계약파일 업로드', '계약서는' + this.limitFileNum + '건까지 업로드 할 수 있습니다.')
          }
        } else {
          this.$refs.confirm.open('alert','계약파일 업로드', this.limitFileSize + 'MB 미만의 파일만 올려주세요.')
        }
      }
      this.uploadFile=[]
    },

    RemovefileList (fileName, index) {
      this.$refs.confirm.open('confirm','계약파일 삭제', fileName + ' 파일을 업로드 대상에서 제외하시겠습니까?' , {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        type: ''
      }).then(() => {
        this.fileList.splice(index, 1)
      })
    },

    submitUpload () {
      var officeContractInfos = []
        if (this.$refs.fileNameForm.validate()) {
          if (this.fileList.length > 0) {
            this.$refs.loading.start(this.fileList.length + '건의 계약서를 업로드 중입니다.')

            for(var i=0; i < this.fileList.length; i++) {
              this.fileData.append('file', this.fileList[i])
            }
            this.fileData.append('contractName',  this.ruleForm.fileName)

            uploadOfficeContract(this.fileData).then(response => {
              this.$refs.loading.end()
              if (response.rdata.rcode === 20000) {
                officeContractInfos.push(response.rdata)
              }
              this.$refs.confirm.open('alert','사내계약', '계약서 업로드가 완료되었습니다.').then(() => {
                this.$store.dispatch('officeContractInfos', officeContractInfos)
              })
            }).catch(e => {
              console.error(e)
            })
          } else {
            this.$refs.confirm.open('alert','계약파일 업로드', '업로드할 계약서를 1개이상 올려주세요.')
          }
        } else {
          this.$refs.confirm.open('alert','계약파일 업로드', '계약서 파일 업로드 전, <strong>계약명을 입력</strong>해주세요. 계약서 파일은 파일명 <strong>[계약명_아이디_이름] 형식</strong>을 지켜주세요.')
        }
    },

    fnPdfDown () {
      window.location.href = process.env.VUE_APP_DOWNLOAD + "officeContract"
    },

  }
}
</script>

<style>
.WCpnstep1_file_inP_box {
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 0;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.WCpnstep1_file_inPCol_box{
  margin-left: 16px;
  padding: 16px 0 10px;
  margin-right: 20px;
  position: relative;
  text-align: right;
}
.inputH48_01.WaddWCpn .v-input__slot {
  margin-right: 14px;
  width: calc(100% - 54px);
}
.addWCpn_ul_box {
    margin: 0;
    width: calc(100% - 54px);
    line-height: 2em;
    font-size: .8rem;
    color: #413f3e;
}
.mdTa-r_sdTa-l{text-align: right;}
.mdTa-r_sdTa-l .btn18_00{margin: 0;}
@media (max-width: 959px) {
  .mdTa-r_sdTa-l{text-align: left;}
  .mdTa-r_sdTa-l .btn18_00{margin-top: 10px;}
}
/* 테이블 */
  .WCpn_cerList-col{
    padding: 16px 0 10px;
    border-left: 1px solid #ccc;
  }
.WCpn_cerListY-scroll{
  padding: 16px 14px 10px;
  max-height: 44vh;
  overflow-y: auto;
}
.WCpn_cerListCon {
    position: relative;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    box-sizing: border-box;
    margin-top: 6px;
    padding: 6px 6px;
    height: auto;
    min-height: 40px;
    overflow: hidden;
    border: 1px solid #ccc !important;
    border-radius: 16px !important;
}

.WCpn_cerListCon:first-child {
    margin-top: 0;
}

.WCpn_cerListCon .carD_box {
    margin-right: 38px;
    padding: 0;
    width: calc(100% - 38px);
    min-height: 40px;
}

.listNum {
  width: 32px;
  font-size:.7rem;
  color: #a4a5a9;
  text-align: center;
}
.list_carD02_ulTxtBox li.li_mg02 {
    margin-right: 40px;
}
@media (max-width: 959px) {
  .WCpn_cerList-col{
    border:none;
    border-top: 1px solid #ccc;
  }
  .WCpn_cerListY-scroll{
    max-height:100%;
  }
}
</style>
